import { motion } from "framer-motion";
import { Info } from "lucide-react";
import { DIRECT_ENTRY_STEPS, DISCLAIMERS } from "@/data/content";
import { SectionHeading } from "@/components/site/primitives";

export function DirectEntry() {
  return (
    <section className="relative py-20 sm:py-28 bg-[#F7F5EF]" data-testid="direct-entry-section">
      <div className="container-x">
        <SectionHeading overline="The Pathway" title="How the Direct Entry Pathway Works"
          subtitle="A clear, structured route from foundation studies toward eligible Direct Entry opportunities." />

        <div className="mt-14 relative">
          <div className="absolute left-0 right-0 top-8 hidden lg:block h-px bg-slate-300" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
            {DIRECT_ENTRY_STEPS.map((s, i) => (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="relative"
              >
                <div className="flex h-16 w-16 items-center justify-center rounded-sm bg-[#0A1E4E] font-serif text-2xl font-bold text-[#D4AF37] shadow-lg">
                  {s.n}
                </div>
                <h3 className="mt-5 font-bold text-lg text-[#0A1E4E]">{s.t}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.d}</p>
              </motion.div>
            ))}
          </div>
        </div>

        <div className="mt-12 flex items-start gap-3 rounded-sm border-l-4 border-[#C0202A] bg-white p-5 text-sm text-slate-700">
          <Info size={18} className="mt-0.5 shrink-0 text-[#C0202A]" />
          <p>{DISCLAIMERS.deAdmission}</p>
        </div>
      </div>
    </section>
  );
}
